import { parseISO } from 'date-fns';

export const getSegment = (x: number, y: number) =>
  document.elementsFromPoint(x, y).find((el) => el.classList.contains('scheduler-segment'));

export const getSegmentFromPoint = (x: number, y: number) =>
  parseISO(getSegment(x, y)?.getAttribute('data-date') || '');
